import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropertyWalkThroughFormSteps from './PropertyWalkThroughFormSteps';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { setPropertyWalkThroughFormStep } from 'src/store/actions/propertyWalkThroughForm';
import { selectSuiteById } from 'src/store/selectors/suites';
import { selectPropertyWalkThroughFormData } from 'src/store/selectors/propertyWalkThroughForm';

const PropertyWalkThroughForm = () => {
  const dispatch = useDispatch();

  const propertyWalkThroughFormData: any = useSelector((state: any) =>
    selectPropertyWalkThroughFormData(state)
  );
  const user: any = useSelector((state: any) => selectAuthenticatedUser(state));
  const suite: any = useSelector((state: any) =>
    selectSuiteById(state, propertyWalkThroughFormData.suiteId)
  );

  const onSetPropertyWalkThroughFormStep = (step: any) =>
    dispatch(setPropertyWalkThroughFormStep(step));

  return (
    <PropertyWalkThroughFormSteps
      propertyWalkThroughFormData={propertyWalkThroughFormData}
      user={user}
      suite={suite}
      onSetPropertyWalkThroughFormStep={onSetPropertyWalkThroughFormStep}
    />
  );
};

export default PropertyWalkThroughForm;
